import Vue from "vue";
import VueRouter from "vue-router";
import Auth from "../views/Auth.vue";
import Main from "../views/Main.vue";
import Maintenance from "../views/Maintenance.vue";
import Login from "../views/Login.vue";
import Logoff from "../views/Logoff.vue";
import Error_page from "../views/Error.vue";

import api from "../services/api";
// import { server } from "../services/constant";
// import store from "@/store";

Vue.use(VueRouter);

const baseRoutes = [
  {
    path: "/",
    name: "Auth",
    component: Auth,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/logoff",
    name: "Logoff",
    component: Logoff,
  },
  {
    path: "/main",
    name: "Main",
    meta: { isSecured: true },
    component: Main,
    children: [
      {
        path: "/",
        name: "Alumni_profile",
        meta: { isSecured: true },
        component: () => import(`@/views/Alumni_profile.vue`),
      },
    ],
  },
];
const routesEnd = [
  {
    path: "/error",
    name: "Error",
    component: Error_page,
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    component: Maintenance,
  },
  {
    path: "*",
    redirect: "/login",
  },
];

const routes = baseRoutes.concat(routesEnd);

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => (record.meta.isSecured ? true : false))) {
    // secure route
    if (api.isLoggedIn()) {
      if ((await api.isCheckToken()) === true) {
        next();
      } else {
        api.logoff();
      } //cehck token
    } else {
      api.logoff();
    }
  } else {
    // unsecure route
    next();
  }
});

export default router;
